import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import Card from '../card/Card';

/**
 * Card wrap around to support delete & hide action
 */
export class InputFormCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShow: true,
    };
  }

  renderAction() {
    const { onDelete, onShowHide, t } = this.props;
    const { isShow } = this.state;
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {onDelete && <Button bsStyle={'danger'} onClick={() => onDelete()}>{t('delete')}</Button>}
        {onShowHide &&
          <ButtonGroup>
            <Button
              color={'secondary'}
              onClick={() => this.setState({ isShow: true }, () => onShowHide(this.state.isShow))}
              active={isShow}
            >
              {t('show')}
            </Button>
            <Button
              color={'secondary'}
              onClick={() => this.setState({ isShow: false }, () => onShowHide(this.state.isShow))}
              active={!isShow}
            >
              {t('hide')}
            </Button>
          </ButtonGroup>
        }
      </div>
    );
  }

  render() {
    const { title, children, fullWidth } = this.props;
    return (
      <Card
        className={`card-rect-input${fullWidth ? ' card-full-width' : ''}`}
        header={title}
        footer={this.renderAction()}
      >
        {children}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/sc_editor/InputFormCard.js